/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import { Button, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import DialogBase from "../../../../Basis/Components/DialogBase";
import DialogContentFieldset from "../../../../Basis/Components/DialogContentFieldset";
import DialogContentFieldsetGroup from "../../../../Basis/Components/DialogContentFieldsetGroup";
import DialogContentText from "../../../../Basis/Components/DialogContentText";
import LoadingIndicatorSuspense from "../../../../Basis/Components/LoadingIndicatorSuspense";
import RichTextInput from "../../../../Basis/Components/RichTextInput";
import TextInput from "../../../../Basis/Components/TextInput";
import { nameof } from "../../../../Basis/Utils/AnyUtil";
import { translationKeys, useTranslation } from "../../Internationalisierung/i18nSupport";
import KontaktformularDialogModel from "./KontaktformularDialogModel";
import KontaktformularDialogProps from "./KontaktformularDialogProps";
import KontaktformularDialogState from "./KontaktformularDialogState";

export default function KontaktformularDialog(props: KontaktformularDialogProps) {
    const vm = new KontaktformularDialogModel(props);
    const { t } = useTranslation();

    return (
        <DialogBase open={vm.isOpen} maxWidth={600}>
            <form
                noValidate
                autoComplete="off"
            >
                <DialogTitle>{t(translationKeys.kontaktformularDialog.dialogTitel)}</DialogTitle>
                <DialogContent>
                    <LoadingIndicatorSuspense>
                        <DialogContentText>{t(translationKeys.kontaktformularDialog.dialogText)}</DialogContentText>
                        <DialogContentFieldsetGroup>
                            <DialogContentFieldset>
                                <TextInput
                                    caption={t(translationKeys.kontaktformularDialog.betreff)}
                                    value={vm.state.betreff}
                                    onChange={vm.aendereWertFuer(nameof<KontaktformularDialogState>("betreff"))}
                                    typBezeichnung={"KontaktformularDialogState"}
                                    feldBezeichnung={nameof<KontaktformularDialogState>("betreff")}
                                    autoFocus
                                    required
                                />
                                <RichTextInput
                                    caption={t(translationKeys.kontaktformularDialog.text)}
                                    value={vm.state.text}
                                    onChange={vm.aendereWertFuer(nameof<KontaktformularDialogState>("text"))}
                                    typBezeichnung={"KontaktformularDialogState"}
                                    feldBezeichnung={nameof<KontaktformularDialogState>("text")}
                                    required
                                />
                            </DialogContentFieldset>
                        </DialogContentFieldsetGroup>
                    </LoadingIndicatorSuspense>
                </DialogContent>
                <DialogActions>
                    <Button onClick={vm.senden} color="primary" disabled={!vm.isComplete} >
                        {t(translationKeys.kontaktformularDialog.senden)}
                    </Button>
                    <Button onClick={vm.abbrechen} color="primary">
                        {t(translationKeys.kontaktformularDialog.abbrechen)}
                    </Button>
                </DialogActions>
            </form>
        </DialogBase>
    );
}